import axiosInstance from "../components/api/axiosInstance";

function normalizeCompanyAccountList(raw) {
  if (raw == null) return [];
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw.data)) return raw.data;
  if (Array.isArray(raw.Data)) return raw.Data;
  if (Array.isArray(raw.company_accounts)) return raw.company_accounts;
  if (Array.isArray(raw.Company_Accounts)) return raw.Company_Accounts;
  if (Array.isArray(raw.items)) return raw.items;
  return [];
}

/**
 * GET company bank accounts (list). Backend may return an array or wrapped payload.
 */
export async function fetchCompanyAccounts() {
  try {
    const response = await axiosInstance.get("/fico/company-accounts");
    return normalizeCompanyAccountList(response.data);
  } catch {
    // Backward compatibility for environments still exposing singular route.
    const fallback = await axiosInstance.get("/fico/company-account");
    return normalizeCompanyAccountList(fallback.data);
  }
}

/**
 * POST create company bank account.
 * @param {Object} payload - API body (Account_Name, Account_Number, etc.)
 */
export async function createCompanyAccount(payload) {
  const response = await axiosInstance.post("/fico/company-account", payload);
  return response.data?.data ?? response.data;
}

/**
 * GET single company bank account by id.
 */
export async function fetchCompanyAccountById(accountId) {
  if (accountId == null || accountId === "") {
    throw new Error("Company account id is required.");
  }
  const response = await axiosInstance.get(`/fico/company-account/${accountId}`);
  const raw = response?.data;
  return raw?.data ?? raw?.Data ?? raw?.company_account ?? raw?.Company_Account ?? raw;
}

/**
 * UPDATE company bank account by id.
 */
export async function updateCompanyAccount(accountId, payload) {
  if (accountId == null || accountId === "") {
    throw new Error("Company account id is required.");
  }
  const response = await axiosInstance.put(`/fico/update-company-account/${accountId}`, payload);
  return response.data?.data ?? response.data;
}

/**
 * DELETE (deactivate) company bank account by id.
 */
export async function deleteCompanyAccount(accountId) {
  if (accountId == null || accountId === "") {
    throw new Error("Company account id is required.");
  }
  const response = await axiosInstance.delete(`/fico/company-account/${accountId}`);
  return response.data?.data ?? response.data;
}
